import { Container } from "react-bootstrap";
import { MessageSquare, Phone, Mail } from 'lucide-react';

function Header() {

    return (
        <section className="contact-header-section">
            {/* Fondo decorativo con formas */}
            <div className="contact-header-background">
                <div className="header-shape header-shape-1"></div>
                <div className="header-shape header-shape-2"></div>
                <div className="header-shape header-shape-3"></div>
                <div className="header-pattern"></div>
            </div>

            <Container className="contact-header-container">
                <div className="contact-header-content">
                    {/* Badge superior */}
                    <div className="header-badge">
                        <MessageSquare size={20} />
                        <span>Estamos aquí para ayudarte</span>
                    </div>

                    {/* Título principal */}
                    <h1 className="contact-header-title">
                        {/* ¿Tienes alguna pregunta?
                        <br /> */}
                        <span className="title-highlight">Contáctanos</span>
                    </h1>

                    {/* Subtítulo */}
                    <p className="contact-header-description">
                        Gracias por tu interés en nuestra empresa. Si tienes alguna consulta o comentario, 
                        estaremos encantados de atenderte a la brevedad posible. 
                        <strong> ¡Agradecemos tu confianza!</strong>
                    </p>

                    {/* Features mini */}
                    {/* <div className="header-features">
                        {features.map((feature, index) => (
                            <div 
                                key={index} 
                                className="feature-item-header"
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <div className="feature-icon-header">
                                    {feature.icon}
                                </div>
                                <span>{feature.text}</span>
                            </div>
                        ))}
                    </div> */}

                    {/* CTA Scroll */}
                    {/* <div className="scroll-indicator">
                        <span>Completa el formulario</span>
                        <ArrowRight size={20} className="arrow-bounce" />
                    </div> */}
                </div>

                {/* Elementos flotantes decorativos */}
                <div className="floating-elements">
                    <div className="floating-icon floating-1">
                        <Phone size={32} />
                    </div>
                    <div className="floating-icon floating-2">
                        <Mail size={32} />
                    </div>
                    <div className="floating-icon floating-3">
                        <MessageSquare size={32} />
                    </div>
                </div>
            </Container>

            {/* Onda decorativa inferior */}
            {/* <div className="header-wave">
                <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"></path>
                </svg>
            </div> */}
        </section>
    );
}

export default Header;